/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelReservation } from './HotelReservation';
import {
    HotelReservationFromJSON,
    HotelReservationFromJSONTyped,
    HotelReservationToJSON,
    HotelReservationToJSONTyped,
} from './HotelReservation';

/**
 * 
 * @export
 * @interface ItineraryHotels
 */
export interface ItineraryHotels {
    /**
     * 
     * @type {Array<HotelReservation>}
     * @memberof ItineraryHotels
     */
    items?: Array<HotelReservation>;
}

/**
 * Check if a given object implements the ItineraryHotels interface.
 */
export function instanceOfItineraryHotels(value: object): value is ItineraryHotels {
    return true;
}

export function ItineraryHotelsFromJSON(json: any): ItineraryHotels {
    return ItineraryHotelsFromJSONTyped(json, false);
}

export function ItineraryHotelsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ItineraryHotels {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(HotelReservationFromJSON)),
    };
}

export function ItineraryHotelsToJSON(json: any): ItineraryHotels {
    return ItineraryHotelsToJSONTyped(json, false);
}

export function ItineraryHotelsToJSONTyped(value?: ItineraryHotels | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(HotelReservationToJSON)),
    };
}

